
import './App.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/css/bootstrap.css';
import '../src/assets/style/component_css/Button.css'
import '../src/assets/style/pages_css/LoginPage.css'
import '../src/assets/style/component_css/Form.css'
import '../src/assets/style/pages_css/Navbar.css'
import '../src/assets/style/pages_css/Sidebar.css'
import '../src/assets/style/data_table/DataTable.css'
import '../src/assets/style/pages_css/Layout.css'
import '../src/assets/style/pages_css/Dashboard.css'
import '../src/assets/style/pages_css/AddOrder.css'
import Login from './pages/login/Login';
import { Navigate, Routes, Route } from 'react-router-dom';
import ProtectedRoutes from './ProtectedRoute';
import Dashboard from './pages/dashboard/Dashboard';
import CustomerList from './pages/customer/CustomerList';
import AddCustomer from './pages/customer/AddCustomer';
import UpdateCustomer from './pages/customer/UpdateCustomer';
import AddBranch from './pages/master/branch/AddBranch';
import UpdateBranch from './pages/master/branch/UpdateBranch';
import AddOrder from './pages/order/AddOrder';
import ApprovedOrder from './pages/order/ApprovedOrder';
import OrderDetails from './pages/order/OrderDetails';
import SalesOrderList from './pages/order/SalesOrderList';
import LedgerList from './pages/ledger/LedgerList';
import InvoiceList from './pages/invoice/InvoiceList';
import ProductList from './pages/Product/ProductList';
import AgeAnalysis from './pages/age-analysis/AgeAnalysis';
import SalesReturnList from './pages/return-list/SalesReturnList';
import DistVoucherList from './pages/discount-voucher-list/DistVoucherList';
import DebitCreditList from './pages/debit-credit-note/DebitCreditNote';
import ApprovalPendingOrder from './pages/order/ApprovalPendingOrder';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/user-login' element={<Login />} />

        <Route element={<ProtectedRoutes />}>
          <Route path='/' element={<Navigate replace to='/dashboard' />} />
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/add-order' element={<AddOrder />} />
          <Route path='/sales-order-list' element={<SalesOrderList />} />
          <Route path='/approval-pending-order' element={<ApprovalPendingOrder />} />
          <Route path='/ledger-list' element={<LedgerList />} />
          <Route path='/age-analysis' element={<AgeAnalysis />} />
          <Route path='/invoice-list' element={<InvoiceList />} />
          <Route path='/product-list' element={<ProductList />} />
          <Route path='/sales-return-list' element={<SalesReturnList />} />
          <Route path='/discount-voucher-list' element={<DistVoucherList />} />
          <Route path='/debit-credit-note' element={<DebitCreditList />} />
        </Route>

        {/* <Route element={<ProtectedRoutes allowedRoles={['teacher', 'student']} />}>
          <Route path='/add-order' element={<AddOrder />} />
          <Route path='/pending-order' element={<PendingOrder />} />
          <Route path='/approved-order' element={<ApprovedOrder />} />
        </Route>

        <Route element={<ProtectedRoutes allowedRoles={['admin']} />}>
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/customer-list' element={<CustomerList />} />
          <Route path='/add-customer' element={<AddCustomer />} />
          <Route path='/update-customer/:id' element={<UpdateCustomer />} />
          <Route path='/branch' element={<AddBranch />} />
          <Route path='/update-branch/:id' element={<UpdateBranch />} />
          <Route path='/admin-pending-order' element={<AdminPendingOrder />} />
          <Route path='/sales-order-list' element={<SalesOrderList />} />
          <Route path='/order-details' element={<OrderDetails />} />
        </Route> */}

      </Routes>
    </div>
  );
}

export default App;
